import React, { Suspense } from 'react';
import ViewArticle from './ArticleManagement/ViewArticle';

const LoadingSpinner = () => (
    <div className="spinner-container">
        <div className="spinner"></div>
    </div>
);
// Lazy-loaded components
const Dashboard = React.lazy(() => import('./Dashboard'));
const PermissionsGrantRevoke = React.lazy(() => import('./AdminConfigurations/PermissionsGrantRevoke.jsx'));
const UserCreateEdit = React.lazy(() => import('./AdminConfigurations/UserCreateEdit.jsx'));
const GroupCreateEdit = React.lazy(() => import('./AdminConfigurations/GroupCreateEdit.jsx'));
const DesignationCreateEdit = React.lazy(() => import('./AdminConfigurations/DesignationCreateEdit.jsx'));
const DepartmentCreateEdit = React.lazy(() => import('./AdminConfigurations/DepartmentCreateEdit.jsx'));
const EditModule = React.lazy(() => import('./AdminConfigurations/ModulesManagement/EditModule.jsx'));
const CreateModule = React.lazy(() => import('./AdminConfigurations/ModulesManagement/CreateModule.jsx'));
const UploadImage = React.lazy(() => import('./Gallery/UploadImage'));
const ViewGallery = React.lazy(() => import('./Gallery/ViewGallery'));
const Article = React.lazy(() => import('./ArticleManagement/Article.jsx'));
const ArticleList = React.lazy(() => import('./ArticleManagement/ArticleList.jsx'));
const ArticleApprove = React.lazy(() => import('./ArticleManagement/ArticleApprove.jsx'));
const CreateCourse = React.lazy(() => import('./Course/Create.jsx'));
const Entities = React.lazy(() => import('./Product/Entities.jsx'));
const Brands = React.lazy(() => import('./Product/Brands.jsx'));
const ProductTypes = React.lazy(() => import('./Product/ProductTypes.jsx'));
const NewProduct = React.lazy(() => import('./Product/NewProduct.jsx'));
const Products = React.lazy(() => import('./Product/Products.jsx'));

// Error Boundary component
class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error loading component:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <div className="error-fallback">Component failed to load</div>;
        }
        return this.props.children;
    }
}

// Wrapper component for consistent loading/error states
const LazyComponent = ({ component: Component, ...props }) => (
    <ErrorBoundary>
        <Suspense fallback={<LoadingSpinner />}>
            <Component {...props} />
        </Suspense>
    </ErrorBoundary>
);

// Screens object with lazy-loaded components
const Screens = {
    Dashboard: (props) => <LazyComponent component={Dashboard} {...props} />,
    PermissionsGrantRevoke: (props) => <LazyComponent component={PermissionsGrantRevoke} {...props} />,
    UserCreateEdit: (props) => <LazyComponent component={UserCreateEdit} {...props} />,
    GroupCreateEdit: (props) => <LazyComponent component={GroupCreateEdit} {...props} />,
    DesignationCreateEdit: (props) => <LazyComponent component={DesignationCreateEdit} {...props} />,
    DepartmentCreateEdit: (props) => <LazyComponent component={DepartmentCreateEdit} {...props} />,
    EditModule: (props) => <LazyComponent component={EditModule} {...props} />,
    CreateModule: (props) => <LazyComponent component={CreateModule} {...props} />,
    UploadImage: (props) => <LazyComponent component={UploadImage} {...props} />,
    ViewGallery: (props) => <LazyComponent component={ViewGallery} {...props} />,
    Article: (props) => <LazyComponent component={Article} {...props} />,
    ArticleList: (props) => <LazyComponent component={ArticleList} {...props} />,
    ArticleApprove: (props) => <LazyComponent component={ArticleApprove} {...props} />,
    ViewArticle: (props) => <LazyComponent component={ViewArticle} {...props} />,
    CreateCourse: (props) => <LazyComponent component={CreateCourse} {...props} />,
    Entities: (props) => <LazyComponent component={Entities} {...props} />,
    Brands: (props) => <LazyComponent component={Brands} {...props} />,
    ProductTypes: (props) => <LazyComponent component={ProductTypes} {...props} />,
    NewProduct: (props) => <LazyComponent component={NewProduct} {...props} />,
    Products: (props) => <LazyComponent component={Products} {...props} />,
};

export default Screens;